module.exports = __webpack_public_path__ + "static/media/leaverequest.e4abafd7.svg";